export default {
	LoadingStatusTrue (state) {
		state.isLoading = true
	},
	LoadingStatusFalse (state) {
		state.isLoading = false
	}
}
